import styled from 'styled-components';
import { desktop1440 } from '@nubank/nuds-web/styles/breakpoints';

import Image from '@nubank/www-latam-commons/components/Image/Image';

const HeroImageBlock = styled(Image)`
  order: 0;

  margin: 0px auto;
  display: block;
  object-fit: cover;
  width: 100vw;
  max-height: 100vh;
  height: 100%;

  ${desktop1440`
    flex-grow: 1;
  `}
`;

HeroImageBlock.displayName = 'HeroImageBlock';

export default HeroImageBlock;
